<div class="label">{{ label }}</div>
<div class="value">
  <a
    *ngIf="link; else rawValue"
    [href]="link"
    target="_blank"
    class="contact-action"
    i2gTrackable
    [trackingAction]="trackingAction"
    [trackingObject]="trackingObject"
    >{{ value }}
  </a>

  <ng-template #rawValue>
    {{ value }}
  </ng-template>
</div>
